import { render, staticRenderFns } from "./tprConfigHistory.vue?vue&type=template&id=688e4c95&"
import script from "./tprConfigHistory.vue?vue&type=script&lang=js&"
export * from "./tprConfigHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports